import PerspectiveHeader from '../PerspectiveCard/PerspectiveHeader';
import styled from '@emotion/styled';

const SublevelHeader = styled(PerspectiveHeader)({
  marginBottom: 0,
});

export default SublevelHeader;
